import { Link } from "react-router-dom";
import { AlertTriangle } from "lucide-react";

// Shown only to logged-in staff (admin/editor) when the public site is in
// maintenance/coming-soon mode. Reminds them the public sees ComingSoon while
// they get a bypass to preview real pages.
export function StaffMaintenanceBanner() {
  return (
    <div
      className="bg-[#C4944A] text-[#1A1A18] border-b-2 border-[#1A1A18]"
      data-testid="staff-maintenance-banner"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-2 flex flex-wrap items-center justify-between gap-3">
        <div className="flex items-center gap-2 font-mono-label text-xs sm:text-sm">
          <AlertTriangle size={14} />
          <span>
            MODE MAINTENANCE ACTIF — les visiteurs voient la page « Coming Soon ». Vous prévisualisez le site.
          </span>
        </div>
        <Link
          to="/admin"
          className="font-mono-label text-xs underline hover:text-[#1A1A18]/70"
          data-testid="staff-maintenance-banner-admin-link"
        >
          Retour à l'admin →
        </Link>
      </div>
    </div>
  );
}
